/**
 * @module Experience/Billing-Details
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const BILLING_DETAILS_CONSTANTS = {
  ADJUSTMENT: 'ZTAD',
  ADJUST: 'Adjustment',
  BILLING_DETAILS_ROUTE: 'billing-details',
  PREPAID: 'PREPAID',
  MRC: 'MRC',
  THIRDPARTY_CHARGES: 'THIRDPARTY_CHARGES',
  ONETIME_CHARGES: 'ONETIME_CHARGES',
  BILLING_DETAILS_MODULE: 'BillingDetailsModule',
  WEB: 'web',
};
